import { gql } from '@apollo/client';

export const queryForLocations = gql`
  query queryForLocations(
    $limit: Int
    $page: Int
    $query: LocationSortOrQuery
    $sort: LocationSortOrQuery
  ) {
    queryForLocations(limit: $limit, page: $page, query: $query, sort: $sort) {
      items {
        id
        state
        county
        township
        updater
        createdAt
        updatedAt
        businessUnits {
          name
        }
      }
      totalRecords
    }
  }
`;
